<div class="flex flex-col w-full">
    <!-- View Mode -->
    <ng-container *ngIf="mode==actionMode.view">
        <!-- Header -->
        <div class="relative w-full min-h-50  px-8 sm:px-12 bg-transparent">
            <!-- Background -->
            <!-- <ng-container>
                <img class="absolute inset-0 object-cover w-full h-full"
                    src="/assets/images/background/header/header-bg2.jpg">
            </ng-container> -->
            <!-- Close button -->
            <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">

                <a mat-icon-button class="frosty-base   frosty-circle" [matTooltip]="'Close'" (click)="closeClicked()">
                    <mat-icon class="text-black icon-size-5" [svgIcon]="'fal:xmark'"></mat-icon>
                </a>

            </div>
        </div>

        <!-- Detail Header Divider -->
        <div class="relative h-1 w-auto rounded-sm mx-2 mt-2  bg-white/50 backdrop-blur-sm"></div>

        <div class="relative flex flex-col flex-auto items-center p-6 pt-0 sm:p-8 sm:pt-0 bg-transparent">
            <div class="w-full max-w-3xl">

                <!-- Avatar and actions -->
                <div class="flex flex-auto items-end -mt-16">
                    <!-- Avatar -->

                    <app-image-editor [editMode]="false" [id]="header.profileImageId" [title]="header.profileImageTitle"
                        [imageUrl]="header.profileImageUrl"></app-image-editor>


                    <!-- Actions -->
                    <div class="flex items-center ml-auto mb-1">

                        <ng-content select="[headerAction]"
                            *ngIf="customHeaderAction else builtInHeaderAction"></ng-content>

                        <ng-template #builtInHeaderAction>
                            <button
                                class="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-md font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none "
                                [matMenuTriggerFor]="menu">
                                <span>{{'SystemAdmin.Components.DrawDetailContainer.View.Header.Actions.Options' |
                                    translate}}</span>
                                <fa-icon [icon]="['fas', 'chevron-down']" class="-mr-1 ml-2"></fa-icon>
                            </button>
                            <mat-menu #menu="matMenu"
                                class=" mt-2  origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <button (click)="editClicked()" mat-menu-item>
                                    <!-- <mat-icon [svgIcon]="'far:pencil'" class="icon-size-4"></mat-icon> -->
                                    <fa-icon [icon]="['fal', 'pencil']" class="mr-2"></fa-icon>
                                    <span> {{'SystemAdmin.Components.DrawDetailContainer.View.Header.Actions.Edit' |
                                        translate}}</span>
                                </button>
                                <button (click)="deleteClicked()" class="text-red-500" mat-menu-item>
                                    <fa-icon [icon]="['fal', 'trash']" class="mr-2"></fa-icon>
                                    <span> {{'SystemAdmin.Components.DrawDetailContainer.View.Header.Actions.Delete' |
                                        translate}}</span>
                                </button>
                            </mat-menu>
                        </ng-template>




                    </div>
                </div>

                <div *ngIf="enableTitle" class="mt-3 text-4xl font-bold truncate">{{title}}</div>



                <div class="flex flex-col mt-10 pt-0  space-y-8">
                    <ng-content select="[view]"></ng-content>
                </div>

            </div>
        </div>
    </ng-container>


    <!-- Edit Mode -->
    <ng-container *ngIf="mode==actionMode.edit || mode==actionMode.add">
        <!-- Header -->
        <div class="relative w-full min-h-50 sm:h-48 px-8 sm:px-12 bg-transparent">
            <!-- Background -->
            <!-- <ng-container>
                <img class="absolute inset-0 object-cover w-full h-full"
                    src="/assets/images/background/header/header-bg2.jpg">
            </ng-container> -->
            <!-- Close button -->
            <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">
                <a mat-icon-button [matTooltip]="'Close'" (click)="closeClicked()">
                    <mat-icon class="text-white icon-size-5" [svgIcon]="'fal:xmark'"></mat-icon>
                </a>
            </div>
        </div>

        <!-- Detail Header Divider -->
        <div class="relative h-1 w-auto rounded-sm mx-2 mt-2  bg-white/50 backdrop-blur-sm"></div>

        <div class="relative flex flex-col flex-auto items-center p-6 pt-0 sm:p-8 sm:pt-0 bg-transparent">
            <div class="w-full max-w-3xl">
                <form [formGroup]="form">

                    <div formGroupName="header" class="flex flex-auto items-end -mt-16">
                        <app-image-editor [editMode]="enablePictureEdit" [id]="header.profileImageId"
                            [title]="header.profileImageTitle" [imageUrl]="header.profileImageUrl"
                            (imageChanged)="imageChanged($event)"></app-image-editor>

                    </div>

                    <div class="flex flex-col mt-10 pt-0 space-y-8">
                        <ng-content select="[edit]"></ng-content>
                    </div>

                    <!-- Actions -->
                    <div class="flex items-center mt-10 p-6 frosty rounded-2xl shadow fix">
                        <!-- Delete -->
                        <button class="frosty red" mat-flat-button *ngIf="mode!=actionMode.add" [color]="'warn'" (click)="deleteClicked()">
                            {{'SystemAdmin.Components.DrawDetailContainer.Footer.Panel.Delete' | translate}}
                        </button>
                        <!-- Cancel -->
                        <button class="ml-auto frosty" mat-flat-button (click)="cancelClicked()">
                            {{'SystemAdmin.Components.DrawDetailContainer.Footer.Panel.Cancel' | translate}}
                        </button>
                        <!-- Save -->
                        <button class="ml-2 frosty green" type="submit" mat-flat-button [color]="'primary'" [disabled]="form.invalid"
                            (click)="saveClicked()">
                            {{'SystemAdmin.Components.DrawDetailContainer.Footer.Panel.Save' | translate}}
                        </button>

                    </div>


                </form>
            </div>
        </div>
    </ng-container>

    <!-- Empty Mode - Minimal template without header/footer -->
    <ng-container *ngIf="mode==actionMode.empty">
            <!-- Header -->
            <div class="relative w-full  px-8 sm:px-12 bg-transparent">
  
                <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">
    
                    <a mat-icon-button class="frosty-base  frosty-circle" [matTooltip]="'Close'" (click)="closeClicked()">
                        <mat-icon class="text-black icon-size-5" [svgIcon]="'fal:xmark'"></mat-icon>
                    </a>
    
    
                </div>
            </div>

        <!-- Full content area without any wrapper constraints -->
        <div class="flex flex-col mt-10 pt-0  px-8 space-y-8">
            <ng-content select="[empty]"></ng-content>
        </div>
    </ng-container>
</div>
